var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"title":""},on:{"close":_vm.onClose}},[_c('video-widget',{attrs:{"videoPackageItem":_vm.packageItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }